import GenericCard from "@ui-components/Card/GenericCard";
import React from "react";
import { ReactComponent as WarningIcon } from "../assets/Icons/Icon_Warning.svg";
import { useLocation } from "react-router-dom";

interface ErrorFetchingItemsProps {
  text: string;
}
interface RouteConfig {
  message: string;
  icon: React.ReactNode;
}

// Map each route to its corresponding configuration.
const routeConfigs: Record<string, RouteConfig> = {
  "/kontrol/cloud-connectivity": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/ipx": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/port": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/datacenter": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/backbone": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/reports": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/internet-ip-monitoring": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/fwaas": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/kontrol/sdwan-hub": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary"/>
  },
  "/account/tags-manager": {
    message: "No information to show",
    icon: <WarningIcon className="h-10 w-10 text-semantic-text-secondary" />,
  },
};

const DEFAULT_WARNING_ICON = (
  <WarningIcon className="h-10 w-10 text-semantic-text-secondary" />
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ErrorFetchingItems: React.FC<ErrorFetchingItemsProps> = ({ text }) => {
  const location = useLocation();
  const currentConfig = getRouteConfig(location.pathname);

  function getRouteConfig(pathname: string) {
    // Try exact match first
    if (routeConfigs[pathname]) return routeConfigs[pathname];
    // Try startsWith for dynamic routes
    const match = Object.keys(routeConfigs).find((key) =>
      pathname.startsWith(key)
    );
    return match ? routeConfigs[match] : null;
  }


  return (
    <div className="min-h-[calc(100vh-10rem)] flex items-center justify-center">
      <div className="w-1/2">
        <GenericCard
          isCollapsible={false}
          bodyContent={
            <div className="flex flex-col items-center justify-center text-center space-y-4 p-6">
              <div className="bg-semantic-bg-secondary inline-flex items-center justify-center border rounded-md p-2">
                {currentConfig?.icon ?? DEFAULT_WARNING_ICON}
              </div>
              {/* Dynamic message */}
              <h3 className="text-1xl font-bold">
                {currentConfig ? currentConfig.message : "No items found"}
              </h3>
              <p className="text-sm text-semantic-text-secondary">
                An error occurred while fetching the data. Please try again later.
              </p>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default ErrorFetchingItems;